import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { getExpeditionIdentifier } from "@/lib/expedition.util";
import { ExpeditionFormProps } from "@/components/backOffice/expeditionForm/expeditionForm.types";
import { QuotationUpdateFinalizedFormStep } from "@/components/backOffice/expeditionForm/quotationExpeditionForm/quotationUpdateFinalizedFormStep";

export const QuotationUpdateExpeditionForm = ({
  expedition,
  company,
  apiEnum,
}: ExpeditionFormProps) => {
  const { t } = useTranslation("boExpeditionForm");
  const expeditionIdentifier = getExpeditionIdentifier(expedition);

  useEffect(() => {
    const defaultTitle = "Pelican Air Services";
    if (expeditionIdentifier) {
      document.title = t("documentTitle.update", { identifier: expeditionIdentifier });
    }
    return () => {
      document.title = defaultTitle;
    };
  }, [expeditionIdentifier, t]);

  return (
    <QuotationUpdateFinalizedFormStep expedition={expedition} company={company} apiEnum={apiEnum} />
  );
};
